import { createApi } from "@reduxjs/toolkit/query/react";
import { privateBaseQuery } from "../base/private/privateBaseQuery";

export interface CodeExecutionLanguage {
    id: number;
    external_id: number;
    code_execution_service_id: number;
    name: string;
    description: string;
    version: string | null;
}

export interface GetCodeExecutionLanguagesParams {
    code_execution_service_id: number;
    limit?: number;
}

export interface CodeExecutionService {
    id: number;
    name: string;
    type: string;
    description?: string;
}

export const codeExecutionApi = createApi({
    reducerPath: "codeExecutionApi",
    baseQuery: privateBaseQuery(),
    tagTypes: ["CodeExecutionLanguages", "CodeExecutionServices"],
    endpoints: (builder) => ({
        getCodeExecutionLanguages: builder.query<
            CodeExecutionLanguage[],
            GetCodeExecutionLanguagesParams
        >({
            query: (params) => ({
                url: "/code-execution-languages",
                method: "GET",
                params,
            }),
            transformResponse: (response: any) => {
                // Fallback for different response structures
                if (Array.isArray(response)) return response;
                if (response.data && Array.isArray(response.data)) return response.data;
                if (response.entities) return response.entities;
                return [];
            },
        }),
        getCodeExecutionServices: builder.query<CodeExecutionService[], void>({
            query: () => ({
                url: "/code-execution-services",
                method: "GET",
            }),
            transformResponse: (response: any) => {
                if (Array.isArray(response)) return response;
                if (response.data && Array.isArray(response.data)) return response.data;
                if (response.entities && Array.isArray(response.entities.data)) return response.entities.data;
                return [];
            },
        }),
    }),
});

export const { useGetCodeExecutionLanguagesQuery, useGetCodeExecutionServicesQuery } = codeExecutionApi;
